import { MB_CONFIG } from '../config'

export default {

    /*
    *    GET /api/v1/patients/files/{patientID}
    */
    getPatientFiles: (patientID) => {
        return axios.get(MB_CONFIG.API_URL + '/files/patient/' + patientID)
    },

    /*
    *    GET /api/v1/patients/{patientID}/files/
    */
    getExaminationFiles: (patientID, examinationID) => {
        return axios.get(MB_CONFIG.API_URL + '/files/patient/' + patientID + '/examination/' + examinationID)
    },

    /*
    *    DELETE /api/v1/patients/files/{fileID}
    */
    deleteFile: (fileID) => {
        return axios.delete(MB_CONFIG.API_URL + '/files/' + fileID)
    },

    uploadURL: (patientID, examinationID) => {
        if (examinationID) {
            return MB_CONFIG.API_URL + '/files/patient/' + patientID + '/examination/' + examinationID + '/upload'
        }
        return MB_CONFIG.API_URL + '/files/patient/' + patientID + '/upload'
    },

    DOWNLOAD: id => axios.get(MB_CONFIG.API_URL + '/files/' + id + '/download', { responseType: 'blob' }),

}
